// Patches Chart.js's Tooltip._getActiveElements so that stale `active`
// references (dataset indices whose controller was destroyed between a
// hover and the next event) are filtered out instead of crashing.
//
// Chart.js 4.5's original (see node_modules/chart.js/dist/chart.js
// around line 9854) does:
//
//   return lastActive.filter((i) =>
//     this.chart.data.datasets[i.datasetIndex] &&
//     this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined
//   );
//
// When React reconciles a chart whose datasets array shrunk or whose
// market changed, `_metasets` can contain a freshly-allocated meta whose
// `controller` is still null (built on-demand by getDatasetMeta). The
// chained `.controller.getParsed(...)` then throws
// "Cannot read properties of null (reading 'getParsed')" during mouseout.
//
// We replace the method with a copy that null-checks every link in the
// chain. All other behavior (mouseout, in-chart-area path) is preserved
// verbatim. Importing this module once at app startup is enough.
import { Tooltip } from 'chart.js';

if (Tooltip && Tooltip.prototype && !Tooltip.prototype.__safeActiveElementsPatched) {
  Tooltip.prototype._getActiveElements = function patchedGetActiveElements(e, lastActive, replay, inChartArea) {
    const options = this.options;
    if (e.type === 'mouseout') {
      return [];
    }
    if (!inChartArea) {
      return lastActive.filter((i) => {
        const ds = this.chart?.data?.datasets?.[i.datasetIndex];
        if (!ds) return false;
        const meta = this.chart.getDatasetMeta(i.datasetIndex);
        const controller = meta && meta.controller;
        if (!controller || typeof controller.getParsed !== 'function') return false;
        try {
          return controller.getParsed(i.index) !== undefined;
        } catch (_err) {
          return false;
        }
      });
    }
    const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
    if (options.reverse) {
      active.reverse();
    }
    return active;
  };
  Tooltip.prototype.__safeActiveElementsPatched = true;
}
